import FileUpload from '@mui/icons-material/FileUpload';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import {
	ChangeEvent,
	ChangeEventHandler,
	PropsWithChildren,
	ReactNode,
} from 'react';

import { Sxable } from 'library/types';

const Input = styled('input')({
	display: 'none',
});

export interface FilesUploadButtonProps extends Sxable {
	disabled?: boolean;
	id: string;
	onChange: ChangeEventHandler<HTMLInputElement>;
	multiple?: boolean;
	// Optional string of accepted file types, e.g. ".jpg,.png,.pdf" see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept
	filesAccepted?: string;
	icon?: ReactNode;
	variant?: 'text' | 'outlined' | 'contained';
	color?:
		| 'inherit'
		| 'secondary'
		| 'primary'
		| 'success'
		| 'error'
		| 'info'
		| 'warning'
		| 'black';
}

export const FileUploadButton = ({
	disabled = false,
	id,
	onChange,
	multiple = false,
	filesAccepted = undefined,
	children,
	sx = [],
	color = 'secondary',
	icon = <FileUpload />,
	variant = 'contained',
}: PropsWithChildren<FilesUploadButtonProps>) => (
	<label htmlFor={id}>
		<Input
			id={id}
			multiple={multiple}
			onChange={(event: ChangeEvent<HTMLInputElement>) => {
				onChange(event);
				event.target.value = '';
			}}
			type="file"
			accept={filesAccepted}
		/>
		<Button
			disabled={disabled}
			startIcon={icon}
			variant={variant}
			color={color}
			size="large"
			component="span"
			sx={[...(Array.isArray(sx) ? sx : [sx])]}>
			{children}
		</Button>
	</label>
);
